import { TextField } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import { useState } from 'react'

export const SORT_ORDER_MIN = 1
export const SORT_ORDER_MAX = 65535

export function clampSortOrder(value: number): number {
  if (!Number.isFinite(value)) {
    return SORT_ORDER_MIN
  }
  return Math.min(SORT_ORDER_MAX, Math.max(SORT_ORDER_MIN, Math.trunc(value)))
}

export function normalizeSortOrderFromApi(value: number | null | undefined): number {
  const n = Number(value ?? SORT_ORDER_MIN)
  if (!Number.isFinite(n) || n < SORT_ORDER_MIN) {
    return SORT_ORDER_MIN
  }
  return clampSortOrder(n)
}

type Props = {
  value: number
  onChange: (next: number) => void
  sx?: SxProps<Theme>
}

export function SortOrderField({ value, onChange, sx }: Props) {
  const [draft, setDraft] = useState<string | null>(null)
  const display = draft ?? String(clampSortOrder(value))

  return (
    <TextField
      size="small"
      placeholder="Порядок"
      type="text"
      inputMode="numeric"
      value={display}
      onChange={(event) => {
        const raw = event.target.value
        if (raw === '' || /^\d+$/.test(raw)) {
          setDraft(raw)
          if (raw !== '') {
            onChange(clampSortOrder(parseInt(raw, 10)))
          }
        }
      }}
      onBlur={() => {
        const parsed = parseInt(draft ?? String(value), 10)
        const next = Number.isFinite(parsed) ? clampSortOrder(parsed) : SORT_ORDER_MIN
        onChange(next)
        setDraft(null)
      }}
      inputProps={{
        min: SORT_ORDER_MIN,
        max: SORT_ORDER_MAX,
        'aria-label': 'Порядок',
      }}
      sx={sx}
    />
  )
}
